export const LUMERAI_ERROR_TYPES = Object.freeze({
  ABORTED: 'aborted',
  API_ERROR: 'api_error',
  HTTP_PREFIX: 'http_',
  ABORT_ERROR: 'AbortError',
  CANCELED_ERROR: 'CanceledError',
});

export const LUMERAI_GENERATION_FAILURE_REASONS = Object.freeze({
  EMPTY_RESPONSE: 'empty_response',
  EXCEPTION: 'exception',
});
